export async function drawLineOnImage(vm) {
  vm.$nextTick(() => {

    const LINE_WIDTH = vm.lineWidth || 5;
    const LINE_COLOR = vm.lineColor || "#756f60";

    const CORNER_RADIUS = vm.cornerRadius || 8;
    const CORNER_FILL = vm.cornerFill || "#8B4513";
    const CORNER_BORDER = vm.cornerBorder || "#ffffff";

    const canvas = document.getElementById("canvas");

    if (!canvas) {
      console.error("Canvas element not found!");
      return;
    }

    const ctx = canvas.getContext("2d");

    if (vm.documentUploaded) {
      const img = new Image();
      img.src = URL.createObjectURL(vm.documentUploaded);

      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;


        const draw = () => {
          ctx.clearRect(0, 0, canvas.width, canvas.height);

          const corners = vm.corners;

          ctx.filter = "blur(8px)";
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          ctx.filter = "none";

          ctx.save();
          ctx.beginPath();
          ctx.moveTo(corners[0][0], corners[0][1]);
          for (let i = 1; i < corners.length; i++) {
            ctx.lineTo(corners[i][0], corners[i][1]);
          }
          ctx.closePath();
          ctx.clip();

          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          ctx.restore();

          ctx.beginPath();
          ctx.moveTo(corners[0][0], corners[0][1]);
          for (let i = 1; i < corners.length; i++) {
            ctx.lineTo(corners[i][0], corners[i][1]);
          }
          ctx.closePath();
          ctx.strokeStyle = LINE_COLOR;
          ctx.lineWidth = LINE_WIDTH;
          ctx.stroke();

          ctx.fillStyle = CORNER_BORDER;
          corners.forEach(([x, y]) => {

            ctx.beginPath();
            ctx.arc(x, y, CORNER_RADIUS + 2, 0, Math.PI * 2);
            ctx.fillStyle = CORNER_BORDER;
            ctx.fill();

            ctx.beginPath();
            ctx.arc(x, y, CORNER_RADIUS, 0, Math.PI * 2);
            ctx.fillStyle = CORNER_FILL;
            ctx.fill();
          });

        };


        draw();


        let draggingIndex = null;

        const getMousePos = (e) => {
          const rect = canvas.getBoundingClientRect();
          return {
            x: (e.clientX - rect.left) * (canvas.width / rect.width),
            y: (e.clientY - rect.top) * (canvas.height / rect.height),
          };
        };

        canvas.onmousedown = (e) => {
          const { x, y } = getMousePos(e);

          vm.corners.forEach((corner, index) => {
            const [cx, cy] = corner;
            const dist = Math.sqrt((x - cx) ** 2 + (y - cy) ** 2);
            if (dist < CORNER_RADIUS + 4 ) {
              draggingIndex = index;
            }
          });
        };

        canvas.onmousemove = (e) => {
          if (draggingIndex === null) return;

          const { x, y } = getMousePos(e);
          vm.corners[draggingIndex] = [x, y];
          vm.corners = [...vm.corners];

          draw();
        };

        canvas.onmouseup = () => {
          draggingIndex = null;
        };

        canvas.onmouseleave = () => {
          draggingIndex = null;
        };

        canvas.ontouchstart = (e) => {
          const touch = e.touches[0];
          const { x, y } = getMousePos(touch);

          vm.corners.forEach((corner, index) => {
            const [cx, cy] = corner;
            const dist = Math.hypot(x - cx, y - cy);
            if (dist < CORNER_RADIUS + 6) {
              draggingIndex = index;
            }
          });
        };

        canvas.ontouchmove = (e) => {
          if (draggingIndex === null) return;
          e.preventDefault();

          const touch = e.touches[0];
          const { x, y } = getMousePos(touch);

          vm.corners[draggingIndex] = [x, y];
          vm.corners = [...vm.corners];
          draw();
        };

        canvas.ontouchend = () => {
          draggingIndex = null;
        };


      };
    }
  });
}